import { AccountBookOutlined, BankOutlined, RiseOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Card, Col, List, Row, Statistic, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getDashboardKpis } from "../../api/dashboardApi";
import { PageHeaderActions } from "../../shared/components/PageHeaderActions";
import { PersistedTable } from "../../shared/components/PersistedTable";
import { formatInr } from "../../shared/utils/currency";
import { formatDate } from "../../shared/utils/date";

export function DashboardPage() {
  const query = useQuery({ queryKey: ["dashboard-kpis"], queryFn: () => getDashboardKpis() });
  const kpi = query.data;

  return (
    <div>
      <PageHeaderActions
        title="Dashboard"
        subtitle={kpi?.financialYear ? `Financial year ${kpi.financialYear}` : "A compact accounting cockpit shaped after the existing MVC skeleton."}
        right={<Button onClick={() => query.refetch()} loading={query.isFetching}>Refresh</Button>}
      />
      <Row gutter={[12, 12]}>
        <Col xs={24} md={6}><Card><Statistic title="Revenue This Month" value={formatInr(kpi?.revenueThisMonth ?? 0)} prefix={<RiseOutlined />} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Expenses This Month" value={formatInr(kpi?.expensesThisMonth ?? 0)} prefix={<AccountBookOutlined />} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Receivables" value={formatInr(kpi?.totalReceivables ?? 0)} prefix={<TeamOutlined />} /></Card></Col>
        <Col xs={24} md={6}><Card><Statistic title="Net Profit FY" value={formatInr(kpi?.netProfitFY ?? 0)} prefix={<BankOutlined />} /></Card></Col>
      </Row>
      <Row gutter={[12, 12]} className="section-card">
        <Col xs={24} lg={12}>
          <Card title="Monthly Trend">
            <PersistedTable
              tableId="dashboard-monthly-trend"
              rowKey="label"
              size="small"
              loading={query.isLoading}
              dataSource={kpi?.monthlyTrend ?? []}
              pagination={false}
              columns={[
                { title: "Month", dataIndex: "label" },
                { title: "Revenue", dataIndex: "revenue", align: "right", render: formatInr },
                { title: "Expenses", dataIndex: "expenses", align: "right", render: formatInr }
              ]}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Recent Activity">
            <List
              loading={query.isLoading}
              dataSource={kpi?.recentActivity ?? []}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta title={`${item.module} ${item.voucherType}`} description={`${formatDate(item.date)} · ${item.description}`} />
                  <Typography.Text strong>{formatInr(item.amount)}</Typography.Text>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
